
import { defineComponent, ref } from 'vue'
import { useFreeFormsModule } from '@/modules/free-forms'
import { useRoute } from 'vue-router'
import { FreeFormsRouteNames } from '@/router/routes-names'
import { SimpleSearchFilter } from '@/views/_shared/search-list/types'
import { FormModelCacheTag, restoreFormModelTo } from '@/modules/_shared/forms'
import FreeFormsList from '@/components/free-forms/free-forms-list.vue'

export default defineComponent({
    name: 'view-free-forms',
    components: { FreeFormsList },
    props: {
        restoreFilters: {
            type: [Boolean, String]
        }
    },
    async setup (props) {
        const { freeForms } = useFreeFormsModule()
        const route = useRoute()

        const restoredFilter = { value: '' } as SimpleSearchFilter
        if (props.restoreFilters) {
            restoreFormModelTo(restoredFilter, FormModelCacheTag.FREE_FORMS_LIST_FILTERS)
        }

        const filter = ref<string>(restoredFilter.value ?? '')

        return {
            filter,
            route,
            freeForms,
            FreeFormsRouteNames
        }
    }
})

